module API.Attachments where

import API.Types (ID, DocumentID)
import GraphQL.Query (Mutation, buildMutation, fileUpload)
import GraphQL.Type (NamedType, QID(..), namedType)
import Internal.Luxon (LDateTime)
import Web.File.File (File)

type Attachment =
    { id :: ID
    , user :: { name :: String }
    , description :: String
    , path :: String
    , url :: String
    , created_at :: LDateTime
    , can :: { delete :: Boolean }
    }

data AttachmentParent = FormAttachment DocumentID
type AttachmentInput =
    { file :: File
    , description :: String
    }

postAttachment :: AttachmentParent -> AttachmentInput -> Mutation Attachment
postAttachment parent input = buildMutation "createAttachment"
    { parent_id: parent'.id
    , parent_type: namedType parent'.type :: NamedType "AttachmentParentType" _
    , data: namedType
        { description: input.description
        , file: fileUpload input.file
        } :: NamedType "AttachmentInput" _
    }
  where
    parent' = case parent of
        FormAttachment id -> { id, type: "FORM" }

deleteAttachment :: ID -> Mutation Attachment
deleteAttachment id = buildMutation "deleteAttachment" { id: QID id }
